export const actions = {
  LOGS_LOAD_REQUESTED: 'LOGS_LOAD_REQUESTED',
  LOGS_LOAD_SUCCEEDED: 'LOGS_LOAD_SUCCEEDED',
  LOGS_LOAD_FILED: 'LOGS_LOAD_FILED',
  JOB_CONFIGS_LOAD_REQUESTED: 'JOB_CONFIGS_LOAD_REQUESTED',
  JOB_CONFIGS_LOAD_SUCCEEDED: 'JOB_CONFIGS_LOAD_SUCCEEDED',
  JOB_CONFIGS_LOAD_FAILED: 'JOB_CONFIGS_LOAD_FAILED',
}

export const getLogsAction = (dispatch, payload) => {
  dispatch({
    type: actions.LOGS_LOAD_REQUESTED,
    payload,
  })
}

export const getJobConfigsAction = dispatch => {
  dispatch({
    type: actions.JOB_CONFIGS_LOAD_REQUESTED,
  })
}
